export enum UIState {
    Empty = 0,
    Loading = 1,
    Loaded = 2,
    Failed = 3,
}
